import * as React from "react";
import request from "src/utils/request";
import { useAuth } from "src/components/providers/auth-context";
import type { TemplateView } from "src/components/template/types";

interface views {
    personalViews?: {
        isDefault: boolean;
        isRepoView: boolean;
        views: TemplateView[];
    }[];
    repoViews?: {
        isDefault: boolean;
        isRepoView: boolean;
        views: TemplateView[];
    }[];
    teamViews?: {
        teamId: string;
        teamName: string;
        views: TemplateView[];
    }[];
    orgViews?: {
        isDefault: boolean;
        views: TemplateView[];
    }[];
    orgTimeseriesViews?: {
        isDefault: boolean;
        views: TemplateView[];
    }[];
}
export const TemplateViewsContext = React.createContext<{ templateViews?: views }>({});

export const TemplateViewsProvider = ({ children }) => {
    const { isDemo, isLoading, jwt } = useAuth();
    const [templateViews, setTemplateViews] = React.useState<views>();
    const getViews = async () => {
        let response: views;
        if (isDemo) {
            // @ts-expect-error expected
            response = (await import("src/components/providers/mock-data/template-views"))
                .default as views;
        } else {
            response = await request<views>(`/api/template/views`);
        }
        setTemplateViews(response);
    };

    React.useEffect(() => {
        if (!isLoading && (isDemo || !!jwt)) {
            getViews();
        }
    }, [isDemo, !!jwt, isLoading]);

    const value = React.useMemo(
        () => ({
            templateViews,
        }),
        [templateViews]
    );
    return <TemplateViewsContext.Provider value={value}>{children}</TemplateViewsContext.Provider>;
};

export const useTemplateViews = () => {
    const context = React.useContext(TemplateViewsContext);
    if (context === undefined) {
        throw new Error(`useTemplateViews must be used within a TemplateViewsProvider`);
    }
    return context;
};
